/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * ProVersion Platform API
 * RECORTE GERADO — nao editar. Produzido por front/scripts/normative-contract.mjs
 * a partir de contract/openapi.yaml, contendo apenas operacoes `x-maturity: normative`.
 *
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BadRequestResponse,
  ForbiddenResponse,
  ListNotificationsParams,
  NotFoundResponse,
  NotificationPage,
  ReminderPolicy,
  ReminderPreferences,
  UnauthorizedResponse,
  UnprocessableEntityResponse
} from '../model';

import { apiFetch } from '../../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getListNotificationsUrl = (params?: ListNotificationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/notifications?${stringifiedParams}` : `/v1/notifications`
}

/**
 * Lista as notificacoes in-app do solicitante.
 * @summary Lista as notificacoes in-app do solicitante
 */
export const listNotifications = async (params?: ListNotificationsParams, options?: Parameters<typeof apiFetch>[1]): Promise<NotificationPage> => {

  return apiFetch<NotificationPage>(getListNotificationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListNotificationsQueryKey = (params?: ListNotificationsParams,) => {
    return [
    `/v1/notifications`, ...(params ? [params] : [])
    ] as const;
    }


export const getListNotificationsQueryOptions = <TData = Awaited<ReturnType<typeof listNotifications>>, TError = UnauthorizedResponse>(params?: ListNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListNotificationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listNotifications>>> = ({ signal }) => listNotifications(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof listNotifications>>>
export type ListNotificationsQueryError = UnauthorizedResponse


export function useListNotifications<TData = Awaited<ReturnType<typeof listNotifications>>, TError = UnauthorizedResponse>(
 params: undefined |  ListNotificationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNotifications>>,
          TError,
          Awaited<ReturnType<typeof listNotifications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNotifications<TData = Awaited<ReturnType<typeof listNotifications>>, TError = UnauthorizedResponse>(
 params?: ListNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNotifications>>,
          TError,
          Awaited<ReturnType<typeof listNotifications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNotifications<TData = Awaited<ReturnType<typeof listNotifications>>, TError = UnauthorizedResponse>(
 params?: ListNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista as notificacoes in-app do solicitante
 */

export function useListNotifications<TData = Awaited<ReturnType<typeof listNotifications>>, TError = UnauthorizedResponse>(
 params?: ListNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListNotificationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMarkNotificationReadUrl = (notificationId: string,) => {




  return `/v1/notifications/${notificationId}/read`
}

/**
 * Marca uma notificacao como lida. Somente o dono.
 * @summary Marca uma notificacao como lida
 */
export const markNotificationRead = async (notificationId: string, options?: Parameters<typeof apiFetch>[1]): Promise<void> => {

  return apiFetch<void>(getMarkNotificationReadUrl(notificationId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getMarkNotificationReadMutationOptions = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markNotificationRead>>, TError,{notificationId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof markNotificationRead>>, TError,{notificationId: string}, TContext> => {

const mutationKey = ['markNotificationRead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markNotificationRead>>, {notificationId: string}> = (props) => {
          const {notificationId} = props ?? {};

          return  markNotificationRead(notificationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkNotificationReadMutationResult = NonNullable<Awaited<ReturnType<typeof markNotificationRead>>>

    export type MarkNotificationReadMutationError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse

    /**
 * @summary Marca uma notificacao como lida
 */
export const useMarkNotificationRead = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markNotificationRead>>, TError,{notificationId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markNotificationRead>>,
        TError,
        {notificationId: string},
        TContext
      > => {
      return useMutation(getMarkNotificationReadMutationOptions(options), queryClient);
    }
    export const getGetMyReminderPreferencesUrl = () => {




  return `/v1/me/reminder-preferences`
}

/**
 * Le as preferencias de lembrete do solicitante. A antecedencia default e
 * de 60 minutos, valor provisorio registrado no roadmap para ratificacao.
 * @summary Le as proprias preferencias de lembrete
 */
export const getMyReminderPreferences = async ( options?: Parameters<typeof apiFetch>[1]): Promise<ReminderPreferences> => {

  return apiFetch<ReminderPreferences>(getGetMyReminderPreferencesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyReminderPreferencesQueryKey = () => {
    return [
    `/v1/me/reminder-preferences`
    ] as const;
    }


export const getGetMyReminderPreferencesQueryOptions = <TData = Awaited<ReturnType<typeof getMyReminderPreferences>>, TError = UnauthorizedResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyReminderPreferences>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyReminderPreferencesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyReminderPreferences>>> = ({ signal }) => getMyReminderPreferences({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyReminderPreferences>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyReminderPreferencesQueryResult = NonNullable<Awaited<ReturnType<typeof getMyReminderPreferences>>>
export type GetMyReminderPreferencesQueryError = UnauthorizedResponse


export function useGetMyReminderPreferences<TData = Awaited<ReturnType<typeof getMyReminderPreferences>>, TError = UnauthorizedResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyReminderPreferences>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyReminderPreferences>>,
          TError,
          Awaited<ReturnType<typeof getMyReminderPreferences>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyReminderPreferences<TData = Awaited<ReturnType<typeof getMyReminderPreferences>>, TError = UnauthorizedResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyReminderPreferences>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyReminderPreferences>>,
          TError,
          Awaited<ReturnType<typeof getMyReminderPreferences>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyReminderPreferences<TData = Awaited<ReturnType<typeof getMyReminderPreferences>>, TError = UnauthorizedResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyReminderPreferences>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Le as proprias preferencias de lembrete
 */

export function useGetMyReminderPreferences<TData = Awaited<ReturnType<typeof getMyReminderPreferences>>, TError = UnauthorizedResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyReminderPreferences>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyReminderPreferencesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPutMyReminderPreferencesUrl = () => {




  return `/v1/me/reminder-preferences`
}

/**
 * Define as preferencias de lembrete do solicitante.
 * @summary Define as proprias preferencias de lembrete
 */
export const putMyReminderPreferences = async (reminderPreferences: ReminderPreferences, options?: Parameters<typeof apiFetch>[1]): Promise<ReminderPreferences> => {

  return apiFetch<ReminderPreferences>(getPutMyReminderPreferencesUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(reminderPreferences)
  }
);}





export const getPutMyReminderPreferencesMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | UnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putMyReminderPreferences>>, TError,{data: ReminderPreferences}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof putMyReminderPreferences>>, TError,{data: ReminderPreferences}, TContext> => {

const mutationKey = ['putMyReminderPreferences'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putMyReminderPreferences>>, {data: ReminderPreferences}> = (props) => {
          const {data} = props ?? {};

          return  putMyReminderPreferences(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutMyReminderPreferencesMutationResult = NonNullable<Awaited<ReturnType<typeof putMyReminderPreferences>>>
    export type PutMyReminderPreferencesMutationBody = ReminderPreferences
    export type PutMyReminderPreferencesMutationError = BadRequestResponse | UnauthorizedResponse | UnprocessableEntityResponse

    /**
 * @summary Define as proprias preferencias de lembrete
 */
export const usePutMyReminderPreferences = <TError = BadRequestResponse | UnauthorizedResponse | UnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putMyReminderPreferences>>, TError,{data: ReminderPreferences}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putMyReminderPreferences>>,
        TError,
        {data: ReminderPreferences},
        TContext
      > => {
      return useMutation(getPutMyReminderPreferencesMutationOptions(options), queryClient);
    }
    export const getGetReminderPolicyUrl = () => {




  return `/v1/reminder-policies`
}

/**
 * Le a politica de lembretes da escola. Exclusiva de Super Admin.
 * @summary Le a politica de lembretes da escola
 */
export const getReminderPolicy = async ( options?: Parameters<typeof apiFetch>[1]): Promise<ReminderPolicy> => {

  return apiFetch<ReminderPolicy>(getGetReminderPolicyUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetReminderPolicyQueryKey = () => {
    return [
    `/v1/reminder-policies`
    ] as const;
    }


export const getGetReminderPolicyQueryOptions = <TData = Awaited<ReturnType<typeof getReminderPolicy>>, TError = UnauthorizedResponse | ForbiddenResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReminderPolicy>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReminderPolicyQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReminderPolicy>>> = ({ signal }) => getReminderPolicy({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReminderPolicy>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReminderPolicyQueryResult = NonNullable<Awaited<ReturnType<typeof getReminderPolicy>>>
export type GetReminderPolicyQueryError = UnauthorizedResponse | ForbiddenResponse


export function useGetReminderPolicy<TData = Awaited<ReturnType<typeof getReminderPolicy>>, TError = UnauthorizedResponse | ForbiddenResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReminderPolicy>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReminderPolicy>>,
          TError,
          Awaited<ReturnType<typeof getReminderPolicy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReminderPolicy<TData = Awaited<ReturnType<typeof getReminderPolicy>>, TError = UnauthorizedResponse | ForbiddenResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReminderPolicy>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReminderPolicy>>,
          TError,
          Awaited<ReturnType<typeof getReminderPolicy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReminderPolicy<TData = Awaited<ReturnType<typeof getReminderPolicy>>, TError = UnauthorizedResponse | ForbiddenResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReminderPolicy>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Le a politica de lembretes da escola
 */

export function useGetReminderPolicy<TData = Awaited<ReturnType<typeof getReminderPolicy>>, TError = UnauthorizedResponse | ForbiddenResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReminderPolicy>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReminderPolicyQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPutReminderPolicyUrl = () => {




  return `/v1/reminder-policies`
}

/**
 * Define a politica de lembretes da escola. Exclusiva de Super Admin.
 * @summary Define a politica de lembretes da escola
 */
export const putReminderPolicy = async (reminderPolicy: ReminderPolicy, options?: Parameters<typeof apiFetch>[1]): Promise<ReminderPolicy> => {

  return apiFetch<ReminderPolicy>(getPutReminderPolicyUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(reminderPolicy)
  }
);}





export const getPutReminderPolicyMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | UnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putReminderPolicy>>, TError,{data: ReminderPolicy}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof putReminderPolicy>>, TError,{data: ReminderPolicy}, TContext> => {

const mutationKey = ['putReminderPolicy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putReminderPolicy>>, {data: ReminderPolicy}> = (props) => {
          const {data} = props ?? {};

          return  putReminderPolicy(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutReminderPolicyMutationResult = NonNullable<Awaited<ReturnType<typeof putReminderPolicy>>>
    export type PutReminderPolicyMutationBody = ReminderPolicy
    export type PutReminderPolicyMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | UnprocessableEntityResponse

    /**
 * @summary Define a politica de lembretes da escola
 */
export const usePutReminderPolicy = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | UnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putReminderPolicy>>, TError,{data: ReminderPolicy}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putReminderPolicy>>,
        TError,
        {data: ReminderPolicy},
        TContext
      > => {
      return useMutation(getPutReminderPolicyMutationOptions(options), queryClient);
    }
